import dayjs from 'dayjs';
import { Contest, ContestParticipant } from 'models';
import { formatDuration } from 'utils/formatDuration';

export function getEventStatusString(contest: Contest, participation?: ContestParticipant | null) {
  const now = dayjs().tz('America/Los_Angeles');
  const participantStatus = participation?.status || 'cards_pending';

  if (contest.status === 'completed') {
    if (participantStatus === 'completed') {
      const place = participation?.place;
      if (place) {
        return `✓ Finished #${place}`;
      } else {
        return '✓ Completed';
      }
    } else {
      return 'Completed';
    }
  } else if (contest.status === 'locked') {
    if (participantStatus === 'completed') {
      return '✓ Locked · Games in progress';
    } else {
      return 'Locked · Games in progress';
    }
  } else if (contest.status === 'active') {
    const locksAtTime = dayjs(contest.locksAt).tz('America/Los_Angeles');
    const locksDiff = locksAtTime.diff(now);
    const durationUntilLocks = dayjs.duration(locksDiff);
    const formattedDuration = formatDuration(durationUntilLocks);
    const timeText = parseInt(formattedDuration) < 0 ? '0' : formattedDuration;

    if (participantStatus === 'completed') {
      return `✓ Joined · Starts in ${timeText}`;
    } else {

      return `Locks in ${timeText}`;
    }
  } else if (contest.status === 'scheduled') {
    const startsAtTime = dayjs(contest.startsAt).tz('America/Los_Angeles');
    const startsDiff = startsAtTime.diff(now);
    const durationUntilStarts = dayjs.duration(startsDiff);
    const startTime = formatDuration(durationUntilStarts);
    return parseInt(startTime) < 0 ? 'Opening soon' : `Opens in ${startTime}`;
  }

  return 'unknown status';
}
